import { useGraphQLQuery } from '@betterment/graphql';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { AccountContentCardDocument } from './graphql/accountContentCard.generated';

import { ContentCardLocation } from '../../../../InAppMessages/data';
import MessageCard from '../../../../InAppMessages/MessageCard';

type Props = {
  location: ContentCardLocation;
};

export const ContentCardView: React.FC<Props> = ({ location }) => {
  const accountId = useRequiredParam('accountId');
  const { data } = useGraphQLQuery(AccountContentCardDocument, { variables: { id: accountId }, throwOnError: true });

  if (
    !data ||
    !(
      data.account.__typename === 'ManagedAccount' ||
      data.account.__typename === 'CashAccount' ||
      data.account.__typename === 'Five29Account'
    )
  ) {
    return null;
  }

  return <MessageCard location={location} goalId={data.account.legacyGoalId} />;
};
